import { DEFAULT_COUNTRY_CODE, getCountryName } from './countries';

/**
 * Maps /api/geo/place response into form state for mailing addresses.
 */
export const mapPlaceToFormValues = (place = {}) => {
  const countryCode = place.countryCode || place.country_code || DEFAULT_COUNTRY_CODE;
  const countryName = place.countryName || place.country_name || getCountryName(countryCode);

  const latitude = place.latitude != null && place.latitude !== ''
    ? parseFloat(place.latitude)
    : null;
  const longitude = place.longitude != null && place.longitude !== ''
    ? parseFloat(place.longitude)
    : null;

  let street = place.street || '';
  if (!street && place.fullAddressResult) {
    street = place.fullAddressResult.split(',')[0]?.trim() || '';
  }

  return {
    street,
    addressLine2: place.addressLine2 || place.address_line_2 || '',
    city: place.city || '',
    state: place.regionCode || place.region_code || '',
    zipCode: place.zip || place.zipCode || '',
    countryCode,
    countryName,
    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null,
  };
};

export const emptyAddressFormValues = () => ({
  street: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  countryCode: '',
  countryName: '',
  latitude: null,
  longitude: null,
});
